export enum PatientStatus {
  Active = 1,
  Inactive = 2,
  Merged = 3,
}
